import { getPersonalData } from '@api/profile';
import { createUser, isVibUser } from '@api/users';
import useToastContext from '@contexts/ToastContext/hook';
import { useTourContext } from '@contexts/TourContext/hook';
import { UseStepper } from '@interfaces/stepper';
// import { useFeatureToggleAccess } from '@hooks/useFeatureToggleAccess';
// import { Link } from '@vibTheme/components/_base/Link';
// import { useSession } from 'next-auth/react';
// import { useRouter } from 'next/router';
import { Typography } from '@vibTheme/components/_base/Typography';
import { useEffect, useState } from 'react';

type TelegramUser = {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  photo_url: string;
  auth_date: number;
  hash: string;
};

export type VerifyUserProps = {
  handleNext: UseStepper['handleNext'];
  handlePrevious?: UseStepper['handlePrevious'];
};

export const VerifyUserTelegramWidget = (props: VerifyUserProps) => {
  const toast = useToastContext();
  const [telegramUser, setTelegramUser] = useState<TelegramUser | null>(null);
  const { getRefElementProps, setCurrentStep } = useTourContext();

  const handleNext = () => {
    props.handleNext();
    setCurrentStep(2);
  };

  const getUserPersonalData = async () => {
    const user = await getPersonalData();
    if (!user) throw new Error('Ocorreu um erro ao buscar os dados do usuário');
    return user;
  };

  const handleIsVibUser = async () => {
    try {
      const user = await getUserPersonalData();
      const data = await isVibUser(user);
      data?.status && handleNext();
    } catch (err) {
      toast.handleError(err, 'Ocorreu um erro ao verificar o usuário');
    }
  };

  const createVibUser = async () => {
    if (!telegramUser) throw new Error();

    try {
      const user = await getUserPersonalData();

      const dto = {
        name: user.name,
        document: user.document,
        cel: user.phone,
        email: user.email,
        botConfigId: 1,
        telegramUserId: telegramUser.id,
        username: telegramUser.username,
        hash: telegramUser.hash,
      };

      await createUser(dto);

      toast.setContent('Usuário criado com sucesso!');
      handleNext();
    } catch (err) {
      toast.handleError(err, 'Ocorreu um erro na criação do usuário');
    }
  };

  useEffect(() => {
    handleIsVibUser();

    const onTelegramAuth = (user: any) => {
      setTelegramUser(user);
    };

    (window as any).onTelegramAuth = onTelegramAuth;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.dataset.telegramLogin =
      process.env.NEXT_PUBLIC_TELEGRAM_VIB_BOT || 'vib_telegram_bot';
    script.dataset.size = 'large';
    script.dataset.onauth = 'onTelegramAuth(user)';
    script.dataset.requestAccess = 'write';

    const container = document.getElementById('telegram-login-widget');
    container?.appendChild(script);

    return () => {
      (window as any).onTelegramAuth = null;
    };
  }, []);

  useEffect(() => {
    telegramUser && createVibUser();
  }, [telegramUser]);

  // const router = useRouter();
  // const { data } = useSession();
  // const { isFeatureEnabled: isLoginTelegramEnabled } = useFeatureToggleAccess({
  //   name: 'loginTelegram',
  //   valuesToValidate: { platformUserId: Number(data?.user?.id) },
  // });

  return (
    <div {...getRefElementProps('bind-telegram')}>
      <Typography component="h1" className="mb-main text-center">
        Verificação de usuário
      </Typography>
      <Typography>
        Ainda não temos seu usuário do Telegram registrado em nossa plataforma.
        <br />
        Para associar sua conta Telegram à Plataforma VibX, você pode clicar no
        botão abaixo:
        {/* {!isLoginTelegramEnabled ? (
          ':'
        ) : (
          <>
            &nbsp;ou acessar a página{' '}
            <strong>Meu Telegram -&gt; Meus Logins</strong> para se cadastrar.
          </>
        )} */}
      </Typography>

      <div className="text-center">
        <div id="telegram-login-widget" className="mt-main" />

        {/* {isLoginTelegramEnabled && (
          <Typography className="pt-md">
            <Link
              href={`/myTelegram/myLogins/create?callbackUrl=${router.asPath}`}
            >
              Acessar a página Meu Telegram -&gt; Meus Logins
            </Link>
          </Typography>
        )} */}
      </div>
    </div>
  );
};
